import {
  styled,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import LibMarkdown, { Options } from "react-markdown";
import remarkGfm from "remark-gfm";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: theme.typography.body1.fontSize,
  padding: theme.spacing(0, 0.5),
  "&:first-of-type": {
    paddingLeft: theme.spacing(0),
  },
  "&:last-of-type": {
    paddingRight: theme.spacing(0),
  },
  border: "none",
}));

const TypographyBold = styled(Typography)({
  fontWeight: 600,
});

// Remove excessive top and bottom margins for first and last paragraph in Markdown block
const StyledParagraph = styled("p")(({ theme }) => ({
  "div > &:first-of-type": {
    marginTop: theme.spacing(0),
  },
  "div > &:last-of-type": {
    marginBottom: theme.spacing(0),
  },
}));

const components: Options["components"] = {
  table(props) {
    return <Table size="small">{props.children}</Table>;
  },
  th(props) {
    return <StyledTableCell>{props.children}</StyledTableCell>;
  },
  tr(props) {
    return <TableRow>{props.children}</TableRow>;
  },
  td(props) {
    return <StyledTableCell>{props.children}</StyledTableCell>;
  },
  tbody(props) {
    return <TableBody>{props.children}</TableBody>;
  },
  thead(props) {
    return <TableHead>{props.children}</TableHead>;
  },
  li(props) {
    return <li style={{ listStyleType: "inherit" }}>{props.children}</li>;
  },
  h1(props) {
    return (
      <TypographyBold as="h1" variant="h1">
        {props.children}
      </TypographyBold>
    );
  },
  h2(props) {
    return (
      <TypographyBold as="h2" variant="h2">
        {props.children}
      </TypographyBold>
    );
  },
  h3(props) {
    return (
      <TypographyBold as="h3" variant="h3">
        {props.children}
      </TypographyBold>
    );
  },
  h4(props) {
    return (
      <TypographyBold as="h4" variant="h4">
        {props.children}
      </TypographyBold>
    );
  },
  h5(props) {
    return (
      <TypographyBold as="h5" variant="h5">
        {props.children}
      </TypographyBold>
    );
  },
  h6(props) {
    return (
      <TypographyBold as="h6" variant="h6">
        {props.children}
      </TypographyBold>
    );
  },
  strong(props) {
    return <TypographyBold as="strong">{props.children}</TypographyBold>;
  },
  p(props) {
    return <StyledParagraph>{props.children}</StyledParagraph>;
  },
};

export const Markdown = (props: { children: string }) => (
  <LibMarkdown remarkPlugins={[remarkGfm]} components={components}>
    {props.children}
  </LibMarkdown>
);
